export default function ({ store, redirect }) {
  const account = store.state.auth.active_pt;

  if (helpers.isEmpty(account)) {
    return redirect('/panel');
  }

  if (!helpers.isEmpty(account) && ['ADMIN', 'LECTURER'].indexOf(account.type) <= -1) {
    return redirect('/panel');
  }
}
